import React from 'react'
import _ from 'lodash'

/**
 * @typedef {object} StatusCellProps
 * @property {number} [rowIndex]
 * @property {{ colProps: object, field: string, title: string, positiveValue: string, negativeValue: string, formatOptions?: { titleCase?: boolean } }} definition
 * @property {Array} [data]
 */
import { Cell } from 'fixed-data-table-2'
import { Icon, utils as tkUtils } from '@adc/ui-core'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const { formatTitleCase } = tkUtils.formatters

const iconPositive = (
  <Icon name='circle' color='success' className={cx('status-icon')} />
)
const iconNegative = (
  <Icon name='circle' color='error' className={cx('status-icon')} />
)

const StatusCell = _props => {
  const renderIcon = (value, { titleCase = false }) => {
    const { positiveValue, negativeValue } = _props.definition
    const formattedValue = titleCase
      ? formatTitleCase(String(value))
      : String(value)

    if (formattedValue === positiveValue) {
      return (
        <span>
          {iconPositive} {formattedValue}
        </span>
      )
    } else if (formattedValue === negativeValue) {
      return (
        <span>
          {iconNegative} {formattedValue}
        </span>
      )
    }

    return formattedValue
  }

  const { rowIndex, definition, data, ...props } = _props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]
  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...props}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{
          width: DataTableUtils.getCellInnerWidth(definition.colProps),
        }}
        className={cx('text-truncate', 'extra-right-padding')}
      >
        {renderIcon(
          _.get(row, field) || row[baseField],
          definition.formatOptions || {}
        )}
      </div>
    </Cell>
  )
}

export default StatusCell
